import { Props as CalculatorRenderPropsProps } from '~utils/renderProps/CalculatorRenderProps';

const commonCalculatorConfig: CalculatorRenderPropsProps['config'] = {
  roomsList: ['meetingRooms', 'offices', 'kitchen'],
  employees: {
    value: 15,
    min: 0,
    max: 2000,
  },
  meetingRooms: {
    value: 0,
    min: 0,
    max: 100,
    default: {
      0: 1,
      100: 3,
      250: 6,
      500: 20,
    },
  },
  offices: {
    value: 0,
    min: 0,
    max: 100,
    default: {
      0: 1,
      100: 5,
      250: 10,
      500: 25,
    },
  },
  kitchen: {
    value: 0,
    min: 0,
    max: 100,
    default: {
      0: 1,
      100: 1,
      250: 4,
      500: 10,
    },
  },

  areaForOnePerson: {
    value: 7.5,
    options: [
      {
        value: 5,
        label: '5 - плотная',
      },
      {
        value: 7.5,
        label: '7,5 - свободная',
      },
      {
        value: 10,
        label: '10 - просторная',
      },
    ],
  },
  areaForOneMeetingRoom: {
    value: 25,
  },
  areaForOneOffice: {
    value: 15,
  },
  areaForOneKitchen: {
    value: 30,
  },
};

export const officeCalculatorConfig: CalculatorRenderPropsProps['config'] = {
  ...commonCalculatorConfig,
  query: { type: 'office' },
  orderTarget: '#order',
};

export const rentCalculatorConfig: CalculatorRenderPropsProps['config'] = {
  ...commonCalculatorConfig,
  query: { typeListing: 'rent' },
};
